"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartStackedBar = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const style_map_js_1 = require("lit/directives/style-map.js");
const dot_styles_1 = require("@/components/common/dot/dot.styles");
/**
 * 전체를 시리즈별 몫으로 나눠 채우는 가로 막대.
 * 범례의 점과 같은 색이어야 하므로 세그먼트도 mm-dot의 tone 색 규칙을 따른다.
 */
let ChartStackedBar = class ChartStackedBar extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    // 색 면만 그리고 이름은 범례가 맡으므로 보조 기술에는 드러내지 않는다.
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-hidden', 'true');
    }
    render() {
        return (0, lit_1.html) `
      ${this.items.map(item => this.renderSegment(item))}
    `;
    }
    renderSegment({ tone, share }) {
        return (0, lit_1.html) `
      <div
        class="segment"
        style=${(0, style_map_js_1.styleMap)({ backgroundColor: (0, dot_styles_1.dotToneColor)(tone), width: `${share}%` })}
      ></div>
    `;
    }
};
ChartStackedBar.styles = (0, lit_1.css) `
    :host {
      --chart-stacked-bar-height: var(--size-16);

      display: flex;
      gap: var(--space-1);
      padding: var(--space-1);
      border-radius: var(--radius);
      background: var(--background-subtle-color);
    }

    .segment {
      height: var(--chart-stacked-bar-height);
      border-radius: var(--radius);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], ChartStackedBar.prototype, "items", void 0);
ChartStackedBar = __decorate([
    (0, decorators_js_1.customElement)('mm-chart-stacked-bar')
], ChartStackedBar);
exports.ChartStackedBar = ChartStackedBar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhcnQtc3RhY2tlZC1iYXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjaGFydC1zdGFja2VkLWJhci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBQzNELDhEQUFzRDtBQUV0RCxtRUFBaUU7QUFTakU7OztHQUdHO0FBRUksSUFBTSxlQUFlLEdBQXJCLE1BQU0sZUFBZ0IsU0FBUSxnQkFBVTtJQUF4Qzs7UUFpQnNCLFVBQUssR0FBMEIsRUFBRSxDQUFBO0lBc0I5RCxDQUFDO0lBcEJDLDBDQUEwQztJQUMxQyxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLGFBQWEsRUFBRSxNQUFNLENBQUMsQ0FBQTtJQUMxQyxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7UUFDUCxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDbkQsQ0FBQTtJQUNILENBQUM7SUFFTyxhQUFhLENBQUMsRUFBRSxJQUFJLEVBQUUsS0FBSyxFQUF1QjtRQUN4RCxPQUFPLElBQUEsVUFBSSxFQUFBOzs7Z0JBR0MsSUFBQSx1QkFBUSxFQUFDLEVBQUUsZUFBZSxFQUFFLElBQUEseUJBQVksRUFBQyxJQUFJLENBQUMsRUFBRSxLQUFLLEVBQUUsR0FBRyxLQUFLLEdBQUcsRUFBRSxDQUFDOztLQUVoRixDQUFBO0lBQ0gsQ0FBQzs7QUFyQ00sc0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7O0dBZWxCLENBQUE7QUFDMEI7SUFBMUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxDQUFDOzhDQUFrQztBQWpCakQsZUFBZTtJQUQzQixJQUFBLDZCQUFhLEVBQUMsc0JBQXNCLENBQUM7R0FDekIsZUFBZSxDQXVDM0I7QUF2Q1ksMENBQWUifQ==